import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import NotFound from "../notfound";
import { Redirect } from "react-router-dom";
import NotAllowed from "../notallowed";

class Route403 extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/403" exact component={NotAllowed} />
          <Route path="/" exact component={NotAllowed} />
          <Route path="/dashbord/xdr" exact component={NotAllowed} />
          <Route path="/dashbord/xdrp" exact component={NotAllowed} />
          <Route path="/dashbord/oxdr" exact component={NotAllowed} />
          <Route path="/dashbord/pink" exact component={NotAllowed} />
          <Route path="/users" exact component={NotAllowed} />
          <Route path="/settings" exact component={NotAllowed} />
          <Route path="/reports" exact component={NotAllowed} />
          <Route path="/*" exact component={NotFound} />
          <Redirect to="/403" />
        </Switch>
      </BrowserRouter>
    );
  }
}
export default Route403;
